
import { useEffect } from 'react'
import config from '@/config'
import * as actions from '@actions'
import * as store from '@/store'
import { useWireValue } from '@forminator/react-wire'

export const usePollRunsheetLock = runsheetDocumentJoinIds => {
    const remoteConfig = useWireValue(store.remoteConfig)
    
    useEffect(() => {
        
        if (remoteConfig?.realtimeEnabled) return
        if (!runsheetDocumentJoinIds?.length) return
        
        const checkRunsheet = async () => {
            try {
                await actions.checkRunsheetLock(runsheetDocumentJoinIds)
            } catch (e) {
                console.error('usePollRunsheetLock#checkRunsheet failed', e)
            }
        }
        
        const t = setInterval(checkRunsheet, config.docStatusPollInterval)
        
        return () => clearInterval(t)
        
    }, [runsheetDocumentJoinIds])
    
}